import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const DriveStatusFilter = ({ setDriveStatus, value }) => {
  const options = [
    {
      label: 'Confirmed',
      value: 'CONFIRMED',
    },
    {
      label: 'Cancelled',
      value: 'CANCELLED',
    },
    {
      label: 'Requested',
      value: 'REQUESTED',
    },
    {
      label: 'Reschedule',
      value: 'RESCHEDULE_REQUESTED',
    },
    {
      label: 'Pending',
      value: 'PENDING',
    },
  ]

  const onChange = checkedValues => {
    setDriveStatus(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default DriveStatusFilter
